import React from 'react';

import { SubProductTile } from '@/components/productDetails/SubProductTile/SubProductTile';
import type { Mode } from '@/utils/constants';

export type SubProductsContainerType = {
  cmsSubProducts: any;
  mode: Mode;
};

export const SubProductsContainer: React.FC<SubProductsContainerType> = ({
  cmsSubProducts,
  mode,
}) => {
  return (
    <div className="mb-4">
      <hr className="mb-6 mt-8" />
      <div className="px-4 pb-4 font-interMedium text-lg md:px-0 md:text-2xl">
        What&apos;s in this pack
      </div>
      <div className="mb-0 grid grid-cols-2 px-4 md:mb-6 md:grid-cols-3 md:px-0 lg:grid-cols-4 xl:max-w-screen-lg	">
        {cmsSubProducts &&
          cmsSubProducts?.map((cmsSubProduct: any, index: number) => (
            <div key={index}>
              <SubProductTile
                sku={cmsSubProduct.product.sku}
                qty={cmsSubProduct.quantity}
                key={cmsSubProduct.product.sku}
                slug={cmsSubProduct.product.slug}
                mode={mode}
                primaryDisplayTag={cmsSubProduct.primaryDisplayTag}
              />
            </div>
          ))}
      </div>
    </div>
  );
};
